import { Loading } from "@admin/components/atoms/Loading";
import { HeroSection } from "@admin/components/organisms/HeroSection";
import {
  useAuthStore,
  useCommonStore,
  useLanguageStore,
} from "@enos-monorepo/lib";
import i18n from "@enos-monorepo/lib/locales/i18n";
import { Suspense, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router";

import KTLayout from "../metronic/app/layouts/demo1.js";
import KTComponent from "../metronic/core/index";
import LoginPage from "./authentication/login.js";
import LocationsPage from "./company/locations/LocationsPage.js";
import PersonnelPage from "./company/personnel/PersonnelPage.js";
import SettingsPage from "./company/settings/SettingsPage.js";
import { ControlPointsPage } from "./food-management/control-points/ControlPointsPage.js";
import { EgenkontrolSettingsPage } from "./food-management/egenkontrol-settings/EgenkontrolSettingsPage.js";
import { FoodManagementReportPage } from "./food-management/food-management-report/FoodManagementReportPage.js";
import { InformationBankPage } from "./food-management/information-bank/InformationBankPage.js";
import PanelLayout from "./layout.js";
import NotFoundPage from "./not-found.js";
import PastShiftsPage from "./shift-management/past-shifts/PastShiftsPage.js";
import ShiftPlanningPage from "./shift-management/shift-planning/ShiftPlanningPage.js";
import { ShiftReportsPage } from "./shift-management/shift-reports/ShiftReportsPage.js";
import TodaysShiftsPage from "./shift-management/todays-shifts/TodaysShiftsPage.js";
import TommorrowsShiftsPage from "./shift-management/tomorrows-shifts/TommorrowsShiftsPage.js";
import { AllCompaniesPage } from "./super-admin/all-companies/AllCompanies.js";

export function App() {
  const location = useLocation();
  const { language } = useLanguageStore();

  useEffect(() => {
    // rehydrate the store
    useAuthStore.persist.rehydrate();
    useCommonStore.persist.rehydrate();
    useLanguageStore.persist.rehydrate();
  }, []);

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  useEffect(() => {
    KTComponent.init();
    KTLayout.init();
  }, [location]);

  return (
    <div className="antialiased flex h-full text-base text-gray-700 [--tw-page-bg-dark:var(--tw-coal-200)] [--tw-content-bg:var(--tw-light)] [--tw-content-bg-dark:var(--tw-coal-500)] [--tw-content-scrollbar-color:#e8e8e8] [--tw-header-height:60px] [--tw-sidebar-width:235px] bg-[--tw-page-bg] dark:bg-[--tw-page-bg-dark] lg:overflow-hidden">
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<PanelLayout />}>
            <Route path="/" element={<HeroSection />} />

            {/* Super Admin Routes */}
            <Route
              path="/super-admin/all-companies"
              element={<AllCompaniesPage />}
            />

            {/* Company Routes */}
            <Route path="/company/locations" element={<LocationsPage />} />
            <Route path="/company/personnel" element={<PersonnelPage />} />
            <Route path="/company/settings" element={<SettingsPage />} />

            {/* Shift Management Routes */}
            <Route
              path="/shift-management/shift-planning"
              element={<ShiftPlanningPage />}
            />
            <Route
              path="/shift-management/todays-shifts"
              element={<TodaysShiftsPage />}
            />
            <Route
              path="/shift-management/past-shifts"
              element={<PastShiftsPage />}
            />
            <Route
              path="/shift-management/tomorrows-shifts"
              element={<TommorrowsShiftsPage />}
            />
            <Route
              path="/shift-management/shift-reports"
              element={<ShiftReportsPage />}
            />

            {/* Food Management Routes */}
            <Route
              path="/food-management/control-points"
              element={<ControlPointsPage />}
            />
            <Route
              path="/food-management/food-management-report"
              element={<FoodManagementReportPage />}
            />
            <Route
              path="/food-management/egenkontrol-settings"
              element={<EgenkontrolSettingsPage />}
            />
            <Route
              path="/food-management/information-bank"
              element={<InformationBankPage />}
            />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </div>
  );
}
